<template>
<!-- 页脚 -->
  <div class="footer">
      <div class='image'>
        <img src='../assets/word.png'/>
      </div>

      <div>
        <!-- <span style='margin-right:10px;'>备案号：闽ICP备2020016439号</span> -->
        <span style='margin-right:10px;'>
          <a href="https://beian.miit.gov.cn/" target="_blank">备案号：闽ICP备2023000601号</a>
          <!-- 备案号：闽ICP备2023000601号-1 -->
        </span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'nav-footer',
  props: {
    
  },
  methods:{
  }
}
</script>

<style scoped lang="scss">
.footer{
  background-color: #F0F0F0;
  width: 100%;
  height:130px;
  text-align:center;
  // opacity: 0.3;
  .image{
    padding: 40px 0 20px;
    width: 300px;
    margin: auto;
    height: 30px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
